<script>
  export let score;

  let scoreClass = function (score) {
    if (score >= 4) {
      return 'green';
    } else if (score >= 3) {
      return 'orange';
    } else {
      return 'red';
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .score-badge {
    font-size: 14px;
    padding: 4px 12px;
    &.green {
      color: $green;
      background-color: $green-light;
    }

    &.orange {
      color: $orange;
      background-color: $orange-light;
    }

    &.red {
      color: $red;
      background-color: $red-light;
    }
  }
</style>

<div class="badge score-badge {scoreClass(score)}">{score}</div>
